export const ADD_TABS = 'ADD_TABS'; // Tab添加
export const REMOVE_TAB = 'REMOVE_TAB'; // Tab删除
export const SELECTED_TABLE = 'SELECTED_TABLE'; // 客户穿梭框内容
export const ADD_HOME = 'ADD_HOME'; // 首页添加内容
export const GET_PRODUCT_DATA = 'GET_PRODUCT_DATA'; //获取产品列表
export const GET_CURRICULUM_DATA = 'GET_CURRICULUM_DATA'; //获取课程列表
export const Get_Product_Property_RelationList = 'Get_Product_Property_RelationList'; //获取产品优惠列表
export const Delete_Product_Property_RelationByID = 'Delete_Product_Property_RelationByID'; //获取产品优惠列表
export const GET_PRODUCT_DISCOUNT_List = 'GET_PRODUCT_DISCOUNT_List'; //获取产品优惠列表
export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOW_PRODUCT = 'SHOW_PRODUCT';
export const ADD_PRODUCT = 'ADD_PRODUCT'; //新增产品
export const UPDATE_PRODUCT_STATU = 'UPDATE_PRODUCT_STATU'; //修改产品状态
export const GET_PRODUCTPACKAGE_DATA = 'GET_PRODUCTPACKAGE_DATA'; //获取产品包列表数据
export const ADD_BATCH_PRODUCT_PACKAGE_DETIAL = 'ADD_BATCH_PRODUCT_PACKAGE_DETIAL'; //调入产品包
export const Update_PRODUCT_PACKGE_STATUS = 'Update_PRODUCT_PACKGE_STATUS'; //更新产品包状态
export const DELETE_PRODUCT_PACKGE = 'DELETE_PRODUCT_PACKGE'; //删除产品包
export const GET_DICTIONARY_BY_TYPEID = 'GET_DICTIONARY_BY_TYPEID'; //获取产品字典表
export const GET_COURSE_SUBTYPE = 'GET_COURSE_SUBTYPE'; //获取课程
export const GET_Dictionary_ByParentId_Type = 'GET_Dictionary_ByParentId_Type'; //获取课程
export const UPDATE_PRODUCT_BY_MODULE = 'UPDATE_PRODUCT_BY_MODULE'; //根据产品id修改更新产品列表数据
export const DELETE_PRODUCT = 'DELETE_PRODUCT'; //根据产品id删除产品
export const DELETE_CURRICULUM = 'DELETE_CURRICULUM'; //根据课程id删除产品
export const CREATE_EDS_CLASS = 'CREATE_EDS_CLASS'; //生成EDS班级
export const GETCLUESGUID = 'GETCLUESGUID'; // 获取客户Guid
export const DISTRIBUTIONGUID = 'DISTRIBUTIONGUID'; // 客户分配获取guid
export const GETKICKPOOL = 'GETKICKPOOL'; // 获取提回公祠选中值
export const CLUESSELECTEDNUM = 'CLUESSELECTEDNUM'; // 选中的客户条数
export const CLUESSHAREDGUID = 'CLUESSHAREDGUID'; // 选中客户共享guid
export const GETCLULEDATA = 'GETCLULEDATA'; // 客户列表查询数据

export const GET_CHANNEL_DATA = 'GET_CHANNEL_DATA'; // 初始化渠道数据
export const UPDATE_CURRENT_CHANNEL = 'UPDATE_CURRENT_CHANNEL'; //  更新当前选中项节点
export const DELETE_CHANNEL_NODE = 'DELETE_CHANNEL_NODE'; // 删除渠道
export const MODIFY_CHANNEL_NAME = 'MODIFY_CHANNEL_NAME'; // 修改渠道名称
export const ADD_CHANNEL_NODE = 'ADD_CHANNEL_NODE'; // 添加节点

export const GET_CUSTOMERSCOURCE_DATA = 'GET_CUSTOMERSCOURCE_DATA'; // 初始化客户来源数据
export const UPDATE_CURRENT_CUSTOMERSCOURCE = 'UPDATE_CURRENT_CUSTOMERSCOURCE'; //  更新客户来源当前选中项节点
export const DELETE_CUSTOMERSCOURCE_NODE = 'DELETE_CUSTOMERSCOURCE_NODE'; // 删除客户来源
export const MODIFY_CUSTOMERSCOURCE_NAME = 'MODIFY_CUSTOMERSCOURCE_NAME'; // 修改客户来源名称
export const ADD_CUSTOMERSCOURCE_NODE = 'ADD_CUSTOMERSCOURCE_NODE'; // 添加客户来源节点

export const GET_SourceDetails_DATA = 'GET_SourceDetails_DATA'; // 初始化来源详情数据
export const UPDATE_CURRENT_SourceDetails = 'UPDATE_CURRENT_SourceDetails'; //  更新来源详情当前选中项节点
export const DELETE_SourceDetails_NODE = 'DELETE_SourceDetails_NODE'; // 删除来源详情
export const MODIFY_SourceDetails_NAME = 'MODIFY_SourceDetails_NAME'; // 修改来源详情名称
export const ADD_SourceDetails_NODE = 'ADD_SourceDetails_NODE'; // 添加来源详情节点




export const SEND_CALL = 'SEND_CALL'; // 打电话
export const GET_CALL_INFO = 'GET_CALL_INFO'; // 通话记录信息
export const CALL_IN_CLUES = 'CALL_IN_CLUES'; // 电话呼入信息
export const CURRENT_SUB_MENU = 'CURRENT_SUB_MENU'; // 电话呼入信息
export const ORDER_CREATE_PRODUCT = 'ORDER_CREATE_PRODUCT'; // 获取已选课程
export const SIGNIN_OUT = "SIGN_IN_OUT"; //签入 签出
export const EXT_STATUS = "EXT_STATUS_Info"; //用户当前状态
export const ORDER_MANAGE_NO = 'ORDER_MANAGE_NO'; // 获取订单管理页每行所选的订单号

export const GET_LISTEN_DATA = 'GET_LISTEN_DATA'; //获取试听列表
export const LISTEN_VAGUE_SEACH_DATA = 'LISTEN_VAGUE_SEACH_DATA'; //获取搜索列表


export const GEt_DEPART_MENT_TREE = 'GEt_DEPART_MENT_TREE'; //获取人员树
export const GEt_TRACKING_IDS = 'GEt_TRACKING_IDS'; //跟进页ID
export const GET_USER_TREE = 'GET_USER_TREE'; // 人员树接口数据

export const GET_ORDERINFO_BYCARDID = 'GET_ORDERINFO_BYCARDID'; //根据身份证获取订单信息
export const CLUES_TABLE_SETTING = 'CLUES_TABLE_SETTING'; // 客户管理自定义显示列
export const CLIENT_TABLE_SETTING = 'CLIENT_TABLE_SETTING'; // 客户管理自定义显示列
export const HANGUP_CALL = "HANGUP_CALL"; //挂断电弧
export const SHOW_TRACKING = "SHOW_TRACKING"; //显示跟进页
export const SHOW_RULERIGHT = "SHOW_RULERIGHT"; //分配规则侧滑
export const SHOW_RECYCLERIGHT = "SHOW_RECYCLERIGHT"; //分配回收规则侧滑
// export const CHOOSE_GUID = "CHOOSE_GUID"; //高亮显示
export const CHANNEL_LOADING = "CHANNEL_LOADING"; // 渠道loading
export const CLUES_HIGHLIGHETED = "CLUES_HIGHLIGHETED"; //拨打电话时客户管理页高亮显示
//电话振铃信息
export const CALL_RING = "CALL_RING_INFO";
export const CLUES_RULE_GUID = "CLUES_RULE_GUID"; // 分配规则Guid
export const CLUES_RECYCLE_GUID = "CLUES_RECYCLE_GUID"; // 回收规则Guid
export const GET_MESSAGE_COUNT = "GET_MESSAGE_COUNT";
//是否通话中
export const CC_CALL_STATUS = "CC_CALL_STATUS";
//天润CC状态
export const TR_CC_CALL_STATUS = "TR_CC_CALL_STATUS";

//天润云呼叫中心
export const TR_CC_CLUDE_STATUS = "TR_CC_CLUDE_STATUS";
//天润云呼叫中心 强制踢下线
export const TR_CC_CLUDE_STATUS_KICKOUT = "TR_CC_CLUDE_STATUS_KICKOUT";
// 当前Tab ID
export const CURRENT_TAB_ID = "CURRENT_TAB_ID";